import React from 'react';
import { connect } from 'react-redux';
import { List, Collapse } from '@mui/material';
import { createActions } from '../../../store';
import CollapsibleSwitchListItem from '../../../../../list-items/CollapsibleSwitchListItem';
import CondensedListItem from '../../../../../list-items/CondensedListItem';
import SwitchListItem from '../../../../../list-items/SwitchListItem';
import TextDriftIntensitySlider from './TextDriftIntensitySlider';
import TextDriftAmplitudeXListItem from './TextDriftAmplitudeXListItem';
import TextDriftAmplitudeYListItem from './TextDriftAmplitudeYListItem';
import TextDriftRotationListItem from './TextDriftRotationListItem';
import TextDriftSpeedListItem from './TextDriftSpeedListItem';
import TextDriftScaleListItem from './TextDriftScaleListItem';
import TextDriftAccelerationListItem from './TextDriftAccelerationListItem';
import { interpolateVisualizerDrift, estimateIntensity, VISUALIZER_ANCHORS } from '../../../Preview/effects/drift/driftUtilities';

const TextDriftListItem = (props) => {
    const { drift, driftEnabled, index, customizeOpen, updateTextElement } = props;

    const onDriftEnabledChange = (value) => updateTextElement(index, { drift: { enabled: value } });

    const onCustomizeChange = (value) => {
        if (value) {
            const params = interpolateVisualizerDrift(drift?.intensity ?? 0);
            updateTextElement(index, { drift: { ...params, customMode: true } });
        } else {
            const intensity = estimateIntensity(drift, VISUALIZER_ANCHORS) ?? drift?.intensity ?? 0;
            updateTextElement(index, { drift: { intensity, customMode: false } });
        }
    };

    return (
        <CollapsibleSwitchListItem
            checked={driftEnabled}
            text='Drift'
            onChange={onDriftEnabledChange}
            dense={false}
        >
            <List dense disablePadding>
                <TextDriftIntensitySlider index={index} />
                <SwitchListItem 
                    text='Custom' 
                    checked={customizeOpen} 
                    onChange={(e) => onCustomizeChange(e.target.checked)} 
                />

                <Collapse in={customizeOpen} timeout="auto" unmountOnExit>
                    <CondensedListItem
                        elements={[
                            { width: 6, component: <TextDriftAmplitudeXListItem index={index} /> },
                            { width: 6, component: <TextDriftAmplitudeYListItem index={index} /> }
                        ]}
                    />
                    <CondensedListItem
                        elements={[
                            { width: 6, component: <TextDriftRotationListItem index={index} /> },
                            { width: 6, component: <TextDriftScaleListItem index={index} /> }
                        ]}
                    />
                    <CondensedListItem
                        elements={[
                            { width: 6, component: <TextDriftSpeedListItem index={index} /> },
                            { width: 6, component: <TextDriftAccelerationListItem index={index} /> }
                        ]}
                    />
                </Collapse>
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state, ownProps) => {
    const drift = state.createPreview.present.videoSettings.text.textElements[ownProps.index].drift;
    const customizeOpen = Boolean(drift?.customMode);
    return {
        drift,
        driftEnabled: drift?.enabled,
        customizeOpen
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return {
        updateTextElement
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextDriftListItem);
